import { getData as apiGetData } from 'api/Api'
import {
  setDefaultDocumentSource,
  setLoadStatus,
  addArray as addDocumentSourceArray
} from '../redux/documentSources'

type Payload = {
  boardId: number
}

export default (payload: Payload) => async dispatch => {
  const { boardId } = payload

  dispatch(setLoadStatus({
    boardId,
    isLoading: true,
    isLoaded: false
  }))

  try {
    const { Sources: DocumentSources, Default } = await apiGetData('AvailableDocumentsSourcesInBoard', {
      boardId
    })

    let documentSources: any[] = []

    DocumentSources.forEach(DocumentSource => {
      const documentSource = {
        id: DocumentSource.Id,
        name: DocumentSource.Name,
        url: DocumentSource.Url
      }

      documentSources.push(documentSource)
    })

    dispatch([
      addDocumentSourceArray({
        boardId,
        array: documentSources
      }),
      setDefaultDocumentSource({
        boardId,
        documentSourceId: Default
      }),
      setLoadStatus({
        boardId,
        isLoading: false,
        isLoaded: true
      })
    ])
  } catch (error) {
    dispatch(setLoadStatus({
      boardId,
      isLoading: false,
      isLoaded: false
    }))
  }
}
